import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { Img } from "@/components/site/ServiceBlocks";
import { ConsultingServices } from "@/components/site/ConsultingServices";
import { AboutContent } from "@/components/site/AboutContent";
import { MethodologyContent } from "@/components/site/MethodologyContent";

const DESIGNED = { "about-us": AboutContent, methodology: MethodologyContent };

const IMAGES = { "about-us": "scientist", consulting: "dashboard", methodology: "dashboard", experts: "lab", "key-sources": "molecules", careers: "lab", contact: "plant" };

export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className={`relative overflow-hidden border-b border-slate-800 bg-slate-950/60 ${image ? "on-photo" : ""}`}>
      {image && <><Img name={image} eager className="absolute inset-0 h-full w-full object-cover opacity-50" /><div className="absolute inset-0 bg-gradient-to-r from-[#090D16] via-[#090D16]/85 to-[#090D16]/30" /></>}
      <div className="relative max-w-[1100px] mx-auto px-4 md:px-8 py-16 md:py-20">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#F58B23] mb-4 fade-up">{eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight fade-up" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-slate-300 mt-5 max-w-3xl text-base md:text-lg fade-up">{subtitle}</p>}
      </div>
    </section>
  );
}

export default function ContentPage() {
  const { slug } = useParams();
  const { data: p, isError } = useQuery({ queryKey: ["page", slug], queryFn: async () => (await api.get(`/pages/${slug}`)).data, retry: false });
  if (isError) return <div className="py-32 text-center"><h1 className="text-3xl font-bold">Page not found</h1></div>;
  if (!p) return <div className="py-24 text-center font-mono text-xs text-slate-500">LOADING…</div>;
  const withForm = ["tech-transfer", "plant-advisory", "consulting"].includes(slug);
  return (
    <div>
      <PageHero eyebrow={p.menu === "legal" ? "Legal" : "CCMIntel"} title={p.title} subtitle={p.subtitle} image={IMAGES[slug]} />
      <div className="max-w-[1100px] mx-auto px-4 md:px-8 py-14">
        {DESIGNED[slug] ? (() => { const C = DESIGNED[slug]; return <C />; })() : <article className="cms-prose" data-testid="page-content" dangerouslySetInnerHTML={{ __html: p.html }} />}
        {slug === "consulting" && <ConsultingServices />}
        {withForm && <div className="mt-16" id="enquire"><EnquiryForm context={slug} title={slug === "plant-advisory" ? "Start a confidential discussion" : "Discuss your project"} /></div>}
      </div>
    </div>
  );
}
